<template>
  <div class="palette-type-list palette-select-list clearfix page_text_font">
    <template
      v-if="item.palette_type == 'manual'&&(item.config[value].image_src||item.config[value].color_code)"
    >
      <div
        class="select-item"
        :class="palette_config&&palette_config.show_style"
        :style="{background:item.config[value].show_type=='show_image'?`url(${item.config[value].image_src}) 0% 0% / cover`:item.config[value].color_code,float:layout
                }"
      ></div>
      <div class="nowarp" :style="layout=='left'?'margin-right:32px':'margin-left:32px'">{{value}}</div>
      <div v-if="main" style="float:right;text-align: right;" class="nowarp">{{item.name}}</div>
    </template>

    <template v-else-if="item.palette_type == 'auto_image'&&item.config[value].default_image_src">
      <div
        style="background-size:cover"
        class="select-item"
        :class="palette_config&&palette_config.show_style"
        :style="{background:`url(${item.config[value].default_image_src}) 0% 0% / cover`,float:layout}"
      ></div>
      <div class="nowarp" :style="layout=='left'?'margin-right:32px':'margin-left:32px'">{{value}}</div>
      <div v-if="main" style="float:right;text-align: right;" class="nowarp">{{item.name}}</div>
    </template>

    <template
      v-else-if="item.palette_type == 'auto_block'&&test_color(value.toString().toLowerCase())"
    >
      <div
        style="background-size:cover;"
        class="select-item"
        :class="palette_config&&palette_config.show_style"
        :style="{background:value.toString().toLowerCase(),float:layout}"
      ></div>
      <div class="nowarp" :style="layout=='left'?'margin-right:32px':'margin-left:32px'">{{value}}</div>
      <div v-if="main" style="float:right;text-align: right;" class="nowarp">{{item.name}}</div>
    </template>

    <template v-else>
      <div class="nowarp" style="display: inline-block;overflow: hidden;" v-if="main">{{item.name}}</div>
      <div style="display: inline-block;overflow: hidden;" v-if="main"> : </div>
      <div class="nowarp" >{{value}}</div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["item", "value", "palette_config", "layout", "main"],
  methods: {
    test_color(e) {
      const color_arr = [
        "IndianRed",
        "LightCoral",
        "Salmon",
        "DarkSalmon",
        "LightSalmon",
        "Crimson",
        "RED",
        "FireBrick",
        "DarkRed",
        "Pink",
        "LightPink",
        "HotPink",
        "DeepPink",
        "MediumVioletRed",
        "PaleVioletRed",
        "LightSalmon",
        "Coral",
        "Tomato",
        "OrangeRed",
        "DarkOrange",
        "Orange",
        "Gold",
        "Yellow",
        "LightYellow",
        "LemonChiffon",
        "LightGoldenrodYellow	",
        "PapayaWhip",
        "Moccasin",
        "PeachPuff",
        "PaleGoldenrod",
        "Khaki",
        "DarkKhaki",
        "Lavender",
        "Thistle",
        "Plum",
        "Violet",
        "Orchid",
        "Fuchsia",
        "Magenta",
        "MediumOrchid",
        "MediumPurple",
        "RebeccaPurple",
        "BlueViolet",
        "DarkViolet",
        "DarkOrchid",
        "DarkMagenta",
        "Purple",
        "Indigo",
        "SlateBlue",
        "DarkSlateBlue",
        "MediumSlateBlue",
        "GreenYellow",
        "Chartreuse",
        "LawnGreen",
        "Lime",
        "LimeGreen",
        "PaleGreen",
        "LightGreen",
        "MediumSpringGreen",
        "SpringGreen",
        "MediumSeaGreen",
        "SeaGreen",
        "ForestGreen",
        "Green",
        "DarkGreen",
        "YellowGreen",
        "OliveDrab",
        "Olive",
        "DarkOliveGreen",
        "MediumAquamarine",
        "DarkSeaGreen",
        "LightSeaGreen",
        "DarkCyan",
        "Teal",
        "Aqua",
        "Cyan",
        "LightCyan",
        "PaleTurquoise",
        "Aquamarine",
        "Turquoise",
        "MediumTurquoise",
        "DarkTurquoise",
        "CadetBlue",
        "SteelBlue",
        "LightSteelBlue",
        "PowderBlue",
        "LightBlue",
        "SkyBlue",
        "LightSkyBlue",
        "DeepSkyBlue",
        "DodgerBlue",
        "CornflowerBlue",
        "MediumSlateBlue",
        "RoyalBlue",
        "Blue",
        "MediumBlue",
        "DarkBlue",
        "Navy",
        "MidnightBlue",
        "Cornsilk",
        "BlanchedAlmond",
        "Bisque",
        "NavajoWhite",
        "Wheat",
        "BurlyWood",
        "Tan",
        "RosyBrown",
        "SandyBrown",
        "Goldenrod",
        "DarkGoldenrod",
        "Peru",
        "Chocolate",
        "SaddleBrown",
        "Sienna",
        "Brown",
        "Maroon",
        "White",
        "Snow",
        "HoneyDew",
        "MintCream",
        "Azure",
        "AliceBlue",
        "GhostWhite",
        "WhiteSmoke",
        "SeaShell",
        "Beige",
        "OldLace",
        "FloralWhite",
        "Ivory",
        "AntiqueWhite",
        "Linen",
        "LavenderBlush",
        "MistyRose",
        "Gainsboro",
        "LightGray",
        "Silver",
        "DarkGray",
        "Gray",
        "DimGray",
        "LightSlateGray",
        "SlateGray",
        "DarkSlateGray",
        "Black"
      ];
      let newArr = [];
      color_arr.forEach(element => {
        newArr.push(element.toLowerCase());
      });
      return newArr.includes(e.toString().toLowerCase());
    }
  },
};
</script>

<style lang="scss" scoped>
.palette-select-list {
  max-width: 400px;
  width: 100%;
  // line-height: 40px;
  // height: 40px;
  // font-family: 'Muli';
  cursor: pointer;

  .nowarp {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: 40%;
  }
  &:hover {
    font-weight: bold;
  }
  .select-item {
    background-size: cover;
    width: 32px;
    height: 32px;
    display: inline-block;
    // vertical-align: middle;
    border-radius: 4px;
    margin: 4px 0;
    margin-right: 12px;
  }
  .right_angle {
    border-radius: 0px !important;
  }
  .round {
    border-radius: 50% !important;
  }
  .fillet {
    border-radius: 4px !important;
  }
}
@media screen and (max-width:768px) {
  .select-content-list {
    .palette-select-list {
      .nowarp {
        // line-height: 40px;
        padding: 5px 15px
      }
    }  
  }
  .palette-select-list {
    max-width: unset;
  }
}
</style>